import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import {
  RoomStreamActiveDeleteCmd,
  RoomStreamActiveSetCmd,
  RoomStreamDeleteCmd
} from "@youm-front/room/domain";
import { RoomStreamActions } from "../actions";
import { RoomStreamEvents } from "../events";
import { RoomStreamSelectors } from "../selectors";

@Injectable()
export class RoomStreamFacade {
  isLoading$ = this.store.pipe(select(RoomStreamSelectors.isLoading));

  constructor(private readonly store: Store) {}

  roomStreamActiveDelete(roomStreamActiveDeleteCmd: RoomStreamActiveDeleteCmd) {
    this.store.dispatch(
      RoomStreamActions.roomStreamActiveDelete({
        roomStreamActiveDeleteCmd
      })
    );
  }

  roomStreamActiveSet(roomStreamActiveSetCmd: RoomStreamActiveSetCmd) {
    this.store.dispatch(
      RoomStreamActions.roomStreamActiveSet({
        roomStreamActiveSetCmd
      })
    );
  }

  roomStreamDeleteEvent(roomStreamDeleteCmd: RoomStreamDeleteCmd) {
    this.store.dispatch(
      RoomStreamEvents.roomStreamDeleteEvent({
        roomStreamDeleteCmd
      })
    );
  }
}
